// AdminSidebar.tsx
import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Package, Users, BarChart2, Settings, ShoppingBag, Home, ChevronDown, ChevronUp } from 'lucide-react'; // Icons

const AdminSidebar: React.FC = () => {
  const location = useLocation();
  const [openSubMenu, setOpenSubMenu] = useState<string | null>(null); // State to manage open sub-menus

  const handleSubMenuToggle = (name: string) => {
    setOpenSubMenu(openSubMenu === name ? null : name);
  };

  const navLinks = [
    { path: '/admin/dashboard', name: 'Dashboard', icon: Home },
    {
      name: 'Product',
      icon: Package,
      subMenu: [
        { path: '/admin/products/create', name: 'Create Product' },
        { path: '/admin/products/list', name: 'Product List' },
      ],
    },
    {
      name: 'Order',
      icon: ShoppingBag,
      subMenu: [
        { path: '/admin/orders/list', name: 'Order List' },
        // { path: '/admin/orders/details', name: 'Order Details' },
        { path: '/admin/orders/cart', name: 'Cart' },
        // { path: '/admin/orders/checkout', name: 'Checkout' },
      ],
    },
    { path: '/admin/live-price', name: 'Todays Price', icon: Users },
    { path: '/admin/customers', name: 'Customer', icon: Users },
    { path: '/admin/reports', name: 'Sales Reports', icon: BarChart2 },
    { path: '/admin/billing', name: 'Billing', icon: Settings },
  ];

  return (
    <div className="fixed top-0 left-0 h-screen w-64 bg-gray-900 text-white flex flex-col pt-20 shadow-xl z-20">
      <div className="p-4">
        <h2 className="text-xl font-semibold mb-6 text-yellow-300">Admin Navigation</h2>
        <nav>
          <ul className="space-y-2">
            {navLinks.map((link) => (
              <li key={link.name}>
                {link.subMenu ? (
                  <>
                    <button
                      className={`flex items-center justify-between w-full p-3 rounded-lg text-lg font-medium transition-all duration-200
                        ${openSubMenu === link.name ? 'bg-yellow-600 text-white shadow-md' : 'text-gray-300 hover:bg-gray-700 hover:text-white'}
                      `}
                      onClick={() => handleSubMenuToggle(link.name)}
                    >
                      <div className="flex items-center">
                        <link.icon className="w-5 h-5 mr-3" />
                        {link.name}
                      </div>
                      {openSubMenu === link.name ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
                    </button>
                    {openSubMenu === link.name && (
                      <ul className="ml-8 mt-2 space-y-1">
                        {link.subMenu.map((subLink) => (
                          <li key={subLink.path}>
                            <Link
                              to={subLink.path}
                              className={`flex items-center p-2 rounded-lg text-md transition-all duration-200
                                ${location.pathname === subLink.path
                                  ? 'bg-yellow-500 text-white'
                                  : 'text-gray-400 hover:bg-gray-700 hover:text-white'
                                }`}
                            >
                              {subLink.name}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    )}
                  </>
                ) : (
                  <Link
                    to={link.path || '#'}
                    className={`flex items-center p-3 rounded-lg text-lg font-medium transition-all duration-200
                      ${location.pathname === link.path
                        ? 'bg-yellow-600 text-white shadow-md'
                        : 'text-gray-300 hover:bg-gray-700 hover:text-white'
                      }`}
                  >
                    <link.icon className="w-5 h-5 mr-3" />
                    {link.name}
                  </Link>
                )}
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default AdminSidebar;